import { Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { first } from 'rxjs';
import { Table } from 'primeng/table';
import { TokenService } from 'src/app/services/common/token.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { BankDetail } from '../../registration/bank-details/bankDetails';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { MenuItem, MessageService } from 'primeng/api';
import saveAs from 'file-saver';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';

@Component({
  selector: 'app-approve-farmers-challan',
  templateUrl: './approve-farmers-challan.component.html',
  styleUrls: ['./approve-farmers-challan.component.scss']
})

export class ApproveFarmersChallanComponent implements OnInit {
  @ViewChild('appFarmerChallanTable', { static: true })
  public appFarmerChallanTable: Table;

  public selectedApplications: any = [];
  public appFarmerChallanModel: any = [];
  public viewChallan: boolean = false;

  public currentDate: Date;

  public challanPrintData: any = [];
  public remarks: any;
  public totalFarmerShareAmount: any = 0;

  public appVerificationItems: MenuItem[];
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];

  public date: any;
  public selectedData: any[];

  constructor(
    private messageService: MessageService,
    private deptDashBoardService: DepartmentDashboardService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService
  ) {}

  ngOnInit() {
    this.loadData(); 

    this.date = new Date();
    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(
            this.selectedApplications,
            `Selected Data For Bank Challan (${this.date})`
          );
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf(
            this.selectedApplications,
            `Selected Data For Bank Challan (${this.date})`
          );
        },
      },
    ];
  }

  loadData() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.loader.start();
    this.deptDashBoardService
      .getDataToPrintMultipleChallanAtal('Generated')
      .pipe(first())
      .subscribe({
        next: (data) => { 
          this.appFarmerChallanModel = data;
          this.loader.close();
          this.appFarmerChallanModel = this.appFarmerChallanModel.map(row => ({
            ...row,
            AppId_ProgID: row.AppId.concat("_", row.ProgID) , 
          }))
          console.log('dataa', this.appFarmerChallanModel);
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Farmer Applications not loaded.',
          });
        },
      });
  }

  onRowUnselect(event) {
    this.calSum();
    this.messageService.add({
      severity: 'info',
      summary: 'Product Unselected',
      detail: event.data.name,
    });
  }

  onRowSelect(event) {
    this.calSum();
    this.messageService.add({
      severity: 'info',
      summary: 'Product Selected',
      detail: event.data.name,
    });
  }

  // printChallan() {
  //   console.log('printChallan', this.selectedApplications);
  //   if (
  //     this.selectedApplications.length == 0 ||
  //     this.selectedApplications == null
  //   ) {
  //     this.messageService.add({
  //       severity: 'info',
  //       summary: 'No Application is selected',
  //       detail: 'Select the Application first.',
  //     });
  //   } else {
  //     let reqBody: any = [];
  //     this.selectedApplications.forEach((val) => {
  //       reqBody.push({ appId: val.appID, progID: val.progID });
  //     });
  //     this.printMultipleChallanAtal(reqBody);
  //     this.viewChallan = true;
  //   }
  // }

  calSum() {
    this.totalFarmerShareAmount = 0;
    this.selectedApplications.forEach((val) => {
      this.totalFarmerShareAmount += val.FarmerShare;
    });
  }

  printMultipleChallanAtal(reqBody) {
    this.loader.start();
    this.deptDashBoardService
      .printMultipleChallanAtal(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.currentDate = new Date();
          this.challanPrintData = data;
          this.loader.close();
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onPrint(divName) {
    // var printContents = document.getElementById(divName).innerHTML;
    // var originalContents = document.body.innerHTML;
    // document.body.innerHTML = printContents;
    // window.print();
    // document.body.innerHTML = originalContents;
    document.body.style.visibility="hidden";
    document.getElementById(divName).style.visibility='visible'
    window.print();
    document.body.style.visibility="visible";
  }

  onBack() {
    this.viewChallan = false;
  }

  onSubmit() {
    this.selectedData = [];

    this.selectedApplications.forEach((row) => {
      this.selectedData.push({
        appID: row.AppId,
        farmerId: row.FarmerId,
        programID: row.ProgID,
      });
    });

    let reqBody = {
      list: this.selectedData,
      remarks: this.remarks ? this.remarks : "",
    };

    this.approveOtherUsersChallan(reqBody);
  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'AppId', header: 'Application ID' },
      { field: 'FarmerId', header: 'Farmer Id' },
      { field: 'ProgID', header: 'Programme ID' },
      { field: 'ProgrammeName', header: 'Programme Name' },
      { field: 'VendorName', header: 'Vendor Name' },
      { field: 'AppUserType', header: 'App User Type' },
      { field: 'ChallanStatus', header: 'Challan Status' },
      { field: 'MIArea', header: 'MIArea' },
      { field: 'Village', header: 'Village' },
      { field: 'Block', header: 'Block' },
      { field: 'District', header: 'District' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      });
    });
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Application Id': d.AppId,
          'Farmer Id': d.FarmerId,
          'Programme ID': d.ProgID,
          'Programme Name': d.ProgrammeName,
          'Vendor Name': d.VendorName,
          'App User Type': d.AppUserType,
          'Challan Status': d.ChallanStatus,
          'MI Area': d.MIArea,
          Village: d.Village,
          Block: d.Block,
          District: d.District,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }


  approveOtherUsersChallan(reqBody) {
    this.loader.start();
    this.deptDashBoardService
      .approveOtherUsersChallan([reqBody])
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.messageService.add({
            severity: 'info',
            summary: 'Status',
            detail: JSON.stringify(data),
          });
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }
}
